<script>
  import { onMount } from 'svelte';
  import { MDCTextField } from '@material/textfield';

  export let id;
  export let label;
  export let value;
  export let type = 'date';
  export let disabled = false;
  export let variant = 'outlined';
  export let min;
  export let max;
  export let name;
  export let valid = true;
  export let invalid_text;
  export let selecting = false;
  export let active_id;

  let text_field;
  let has_field_init = false;
  let focus = false;
  let has_init = true;

  const init_selector = () => {
    let element = document.getElementById(`${id}-date`);
    text_field = new MDCTextField(element);
    has_init = true;
  };

  const field_on_click = () => {
    if (focus && !selecting) selecting = true;
  };

  const on_focus = () => {
    focus = !focus;
    active_id = id;
    has_field_init = false;
    if (!selecting && focus) selecting = true;
    if (selecting && !focus) selecting = false;
  };

  $: if (!!value && has_init && !has_field_init) {
    has_field_init = true;
  }

  onMount(init_selector);
</script>

<div class='position-relative'>

  {#if variant === 'filled'}
    <label id={`${id}-date`}
           class:disabled-bg={disabled}
           class='mdc-text-field mdc-text-field--filled '
           class:mdc-text-field--invalid={!valid && selecting}
           class:mdc-text-field--disabled={disabled}
           class:mdc-text-field--label-floating={has_field_init}>
      <span class='mdc-text-field__ripple'></span>
      <span class='mdc-floating-label'
            id={`${id}-label`}
            class:mdc-floating-label--float-above={has_field_init}>
        {label}
      </span>

      {#if type === 'date'}
        <input id={`${id}-input`}
               class='mdc-text-field__input'
               type='date'
               {name}
               {min}
               {max}
               aria-labelledby={`${id}-label`}
               on:focus={on_focus}
               on:blur={on_focus}
               on:click={field_on_click}
               bind:value={value}
               {disabled}>
      {:else if type === 'datetime-local'}
        <input id={`${id}-input`}
               class='mdc-text-field__input'
               type='datetime-local'
               {name}
               {min}
               {max}
               aria-labelledby={`${id}-label`}
               on:focus={on_focus}
               on:blur={on_focus}
               on:click={field_on_click}
               bind:value={value}
               {disabled}>
      {:else if type === 'time'}
        <input id={`${id}-input`}
               class='mdc-text-field__input'
               type='time'
               {name}
               {min}
               {max}
               aria-labelledby={`${id}-label`}
               on:focus={on_focus}
               on:blur={on_focus}
               on:click={field_on_click}
               bind:value={value}
               {disabled}>
      {/if}
      <span class='mdc-line-ripple'></span>
    </label>
  {:else}
    <label id={`${id}-date`}
           class:disabled-bg={disabled}
           class='mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon'
           class:mdc-text-field--invalid={!valid && selecting}
           class:mdc-text-field--disabled={disabled}
           class:mdc-text-field--label-floating={has_field_init}>
  <span class='mdc-notched-outline'>
    <span class='mdc-notched-outline__leading'></span>
    <span class='mdc-notched-outline__notch'>
      <span class='mdc-floating-label'
            id={`${id}-label`}
            class:mdc-floating-label--float-above={has_field_init}>
        {label}
      </span>
    </span>
    <span class='mdc-notched-outline__trailing'></span>
  </span>
      {#if type === 'date'}
        <input id={`${id}-input`}
               class='mdc-text-field__input'
               type='date'
               {name}
               {min}
               {max}
               aria-labelledby={`${id}-label`}
               on:focus={on_focus}
               on:blur={on_focus}
               on:click={field_on_click}
               bind:value={value}
               {disabled}>
      {:else if type === 'datetime-local'}
        <input id={`${id}-input`}
               class='mdc-text-field__input'
               type='datetime-local'
               {name}
               {min}
               {max}
               aria-labelledby={`${id}-label`}
               on:focus={on_focus}
               on:blur={on_focus}
               on:click={field_on_click}
               bind:value={value}
               {disabled}>
        {:else if type === 'time'}
        <input id={`${id}-input`}
               class='mdc-text-field__input'
               type='time'
               {name}
               {min}
               {max}
               aria-labelledby={`${id}-label`}
               on:focus={on_focus}
               on:blur={on_focus}
               on:click={field_on_click}
               bind:value={value}
               {disabled}>
      {/if}
    </label>
  {/if}

  {#if !valid && selecting}
    <div class='tooltip-error'>
      <span class='tooltip-text tooltip-top' id={`${id}-invalid`}>{invalid_text}</span>
    </div>
  {/if}
</div>

<style>
    input{
        cursor: text;
    }
    .disabled-bg {
        opacity: 0.5;
        transition: all 0.2s ease-in-out;
    }

    .mdc-text-field{
        width: inherit;
        transition: all 0.2s ease-in-out;
    }
    .mdc-text-field--with-trailing-icon.mdc-text-field--outlined .mdc-text-field__input {
        padding-right: 15px;
    }

    .mdc-text-field--with-trailing-icon .mdc-text-field__input {
        padding-right: 15px;
    }

    .position-relative {
        position: relative;
        width: inherit;
    }

    .tooltip-error {
        position: relative;
        font-size: 12px;
        top: -50px;
        z-index: 12;
    }

    .tooltip-error .tooltip-top {
        position: absolute;
        z-index: 1;
        bottom: 100%;
        left: 50%;
        right: 0;
    }

    .tooltip-error .tooltip-text {
        background-color: var(--invalid-color);
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 8px 8px;
    }
</style>